.content {
  max-width: 800px;
  margin: auto;
}
